import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LogoutComponent } from './pages/logout/logout.component';

@NgModule({
    declarations: [LogoutComponent],
    imports: [CommonModule],
})
export class LogoutModule {}
